import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InvoicePreviewLayer from "../components/InvoicePreviewLayer";
import { useParams } from "react-router-dom";
import { API_URL } from "..";

const InvoicePreviewPage = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    const fetchSingle = async () => {
      setLoading(true);
      setError("");
      setData(null);
      try {
        const response = await fetch(API_URL + "/api/invoice/" + id, {
          method: "GET",
          headers: { Accept: "application/json" },
          signal: controller.signal,
        });
        if (!response.ok) {
          throw new Error(response.status === 404
            ? "Order Form not found."
            : "Unable to load the Order Form. Please try again.");
        }
        const result = await response.json();
        if (!result || result.invoice_number === undefined) {
          throw new Error("The server returned an invalid Order Form. Please try again.");
        }
        if (!controller.signal.aborted) setData(result);
      } catch (err) {
        if (!controller.signal.aborted) {
          setError(err instanceof TypeError
            ? "Cannot connect to the server. Check that the backend is running, then retry."
            : err.message || "Unable to load the Order Form. Please try again.");
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };
    fetchSingle();
    return () => controller.abort();
  }, [id, retryCount]);

  return (
    <MasterLayout>
      <Breadcrumb title="Order Form - Preview" />
      {loading && <p role="status">Loading Order Form...</p>}
      {error && (
        <div className="alert alert-danger" role="alert">
          <p className="mb-2">{error}</p>
          <button type="button" className="btn btn-primary btn-sm" onClick={() => setRetryCount((count) => count + 1)}>
            Retry
          </button>
        </div>
      )}
      {!loading && !error && data && <InvoicePreviewLayer sampleData={data} />}
    </MasterLayout>
  );
};

export default InvoicePreviewPage;
